import { TargetScoreRangeInputValidationError } from '../types';

export function determineTargetScoreRangeInputValidationError(min: number | null, max: number | null) {
  if (min === null && max !== null) return TargetScoreRangeInputValidationError.MinNullMaxNotNull;
  if (min !== null && max === null) return TargetScoreRangeInputValidationError.MinNotNullMaxNull;
  if (min !== null && max !== null && min > max) return TargetScoreRangeInputValidationError.MinGreaterThanMax;
}
